'use strict';

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

var _NavigatorEvent = require('./NavigatorEvent');

var NavigatorEvent = _interopRequireWildcard(_NavigatorEvent);

var _NavigationBehaviors = require('./NavigationBehaviors');

var NavigationBehaviors = _interopRequireWildcard(_NavigationBehaviors);

var _ResponderLists = require('./ResponderLists');

var _ResponderLists2 = _interopRequireDefault(_ResponderLists);

var _NavigationState = require('./NavigationState');

var _NavigationState2 = _interopRequireDefault(_NavigationState);

var _NavigationResponderBehaviors = require('./NavigationResponderBehaviors');

var _NavigationResponderBehaviors2 = _interopRequireDefault(_NavigationResponderBehaviors);

var _History = require('./History');

var _History2 = _interopRequireDefault(_History);

var _AsynchResponders = require('./AsynchResponders');

var _AsynchResponders2 = _interopRequireDefault(_AsynchResponders);

var _Navigator = require('./Navigator');

var _Navigator2 = _interopRequireDefault(_Navigator);

var _Bind = require('./utils/Bind');

var _Bind2 = _interopRequireDefault(_Bind);

var _AutoBind = require('./utils/AutoBind');

var _AutoBind2 = _interopRequireDefault(_AutoBind);

var _DebugConsole = require('./features/DebugConsole');

var _DebugConsole2 = _interopRequireDefault(_DebugConsole);

var _TransitionStatus = require('./transition/TransitionStatus');

var TransitionStatus = _interopRequireWildcard(_TransitionStatus);

var _TransitionCompleteDelegate = require('./transition/TransitionCompleteDelegate');

var _TransitionCompleteDelegate2 = _interopRequireDefault(_TransitionCompleteDelegate);

var _ValidationPreparedDelegate = require('./transition/ValidationPreparedDelegate');

var _ValidationPreparedDelegate2 = _interopRequireDefault(_ValidationPreparedDelegate);

var _StateCommandMap = require('./integration/StateCommandMap');

var _StateCommandMap2 = _interopRequireDefault(_StateCommandMap);

var _ViewRecipe = require('./integration/ViewRecipe');

var _ViewRecipe2 = _interopRequireDefault(_ViewRecipe);

var _StateUrlSyncer = require('./integration/StateUrlSyncer');

var _StateUrlSyncer2 = _interopRequireDefault(_StateUrlSyncer);

var _StateViewMap = require('./integration/StateViewMap');

var _StateViewMap2 = _interopRequireDefault(_StateViewMap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak
// navigator-main
var utils = (0, _freeze2.default)({
    Bind: _Bind2.default,
    AutoBind: _AutoBind2.default
});
var features = (0, _freeze2.default)({
    DebugConsole: _DebugConsole2.default
});

var transition = (0, _freeze2.default)({
    TransitionStatus: TransitionStatus,
    TransitionCompleteDelegate: _TransitionCompleteDelegate2.default,
    ValidationPreparedDelegate: _ValidationPreparedDelegate2.default
});

var integration = (0, _freeze2.default)({
    ViewRecipe: _ViewRecipe2.default,
    StateCommandMap: _StateCommandMap2.default,
    StateUrlSyncer: _StateUrlSyncer2.default,
    StateViewMap: _StateViewMap2.default
});

module.exports = (0, _freeze2.default)({
    NavigatorEvent: NavigatorEvent,
    NavigationBehaviors: NavigationBehaviors,
    ResponderLists: _ResponderLists2.default,
    NavigationState: _NavigationState2.default,
    NavigationResponderBehaviors: _NavigationResponderBehaviors2.default,
    History: _History2.default,
    AsynchResponders: _AsynchResponders2.default,
    Navigator: _Navigator2.default,
    utils: utils,
    features: features,
    transition: transition,
    integration: integration
});
//# sourceMappingURL=index.js.map